import { cva, type VariantProps } from 'class-variance-authority'
import { FC, HTMLAttributes, Ref } from 'react'

import { cn } from '../utils/cn'

const BASE_CHIP_CLASS_NAME = `
  inline-flex gap-x-2 items-center rounded justify-center uppercase font-medium tracking-wider w-max
`

export const chipVariants = cva(BASE_CHIP_CLASS_NAME, {
  variants: {
    color: {
      amber: 'bg-amber-100 text-amber-900',
      teal: 'bg-teal-100 text-teal-900',
      purple: 'bg-purple-100 text-purple-900',
      green: 'bg-green-100 text-green-900',
      red: 'bg-red-100 text-red-900',
      gray: 'bg-gray-100 text-gray-900',
      blue: 'bg-blue-100 text-blue-900',
      orange: 'bg-orange-100 text-orange-900',
      yellow: 'bg-yellow-100 text-yellow-900',
      darkRed: 'bg-red-700 text-white',
      darkTeal: 'bg-teal-700 text-white'
    },
    size: {
      sm: 'px-2 h-5 text-xxs gap-x-1',
      base: 'px-3 h-6 text-xs',
      l: 'px-3 h-7 text-base'
    }
  },
  defaultVariants: {
    size: 'base',
    color: 'gray'
  }
})

export type ChipVariantsType = VariantProps<typeof chipVariants>

interface ChipProps
  extends Omit<HTMLAttributes<HTMLElement>, 'color'>,
    ChipVariantsType {
  ref?: Ref<HTMLSpanElement>
}

export const Chip: FC<ChipProps> = ({
  children,
  className,
  size,
  color,
  ref,
  ...props
}) => {
  const chipClassName = cn(
    chipVariants({
      size,
      color
    }),
    className
  )

  return (
    <span {...props} className={chipClassName} ref={ref}>
      {children}
    </span>
  )
}
